import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getProcedureRows } from "./procedure-rows";

export const metadata = {
  tableType: "Procedure",
  displayName: "Procedures",
  getRows: (bundle: FhirBundleSdk) => getProcedureRows({ bundle }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Only include fields that are visible in the table:
    // Procedure (title/name), Type, Body Region, Date Performed, Status
    const searchableFields = ["procedure", "type", "bodyRegion", "datePerformed", "status"];

    const rowValues = searchableFields
      .map(key => String(row[key] ?? ""))
      .filter(val => val && val !== "-")
      .join(" ");

    return rowValues.toLowerCase();
  },
};
